module.exports = __webpack_public_path__ + "media/fail.a3e9634d.mp3";